import React, {useState, useEffect} from 'react';
import Accordion from "./Accordion";
import {Link, useNavigate} from "react-router-dom";
import PopupLogin from "../popuplogin/PopupLogin";
import "./Accordion.css"
import ServicesLoader from "./ServicesLoader";
import {jwtDecode} from "jwt-decode";
import {useTranslation} from "react-i18next";
import {AiFillFile} from "react-icons/ai";
import {Button} from "@mui/material";

function Services() {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [accordionData, setAccordionData] = useState([]);
    const [roleId, setRoleId] = useState("");
    const {i18n} = useTranslation();
    const navigate = useNavigate();
    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);

    const handleLinkClick = (accordionItem) => {
        if (roleId === "USER") {
            navigate(`/dashboard/newcase?id=${accordionItem.id}&parentId=${accordionItem.permitTypeId || ''}`);
        } else {
            setIsPopupOpen(true);
        }
    };

    const togglePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    useEffect(() => {
        const fetchAccordionData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const data = await response.json();
                setAccordionData(data.data || []);
                setIsLoading(false)
            } catch (error) {
            }
        };

        void fetchAccordionData();
    }, []);

    const renderAccordion = (accordionItem) => {
        const isLastLevel = !accordionItem.childrenPermitTypes || accordionItem.childrenPermitTypes.length === 0;


        if (isLastLevel) {
            return (
                <div key={accordionItem.id}
                     style={{
                         color: '#3872F2',
                         fontFamily: "'FiraGO-SemiBold'",
                         textDecoration: 'none',
                         maxWidth: '85%',
                         marginBottom: 5
                     }}
                >


                    {accordionItem.url ? (
                        <Button
                            component={Link}
                            to={`${accordionItem.url}?permiturl=${accordionItem.id}&parentId=${accordionItem.permitTypeId}`}
                            startIcon={<AiFillFile />} // Replace AiFillFile with your desired icon
                            style={{
                                color: '#3872F2',
                                fontFamily: "'FiraGO-SemiBold'",
                                textDecoration: 'none',
                                textTransform: 'none' // Keeps the text in Button from being uppercase by default
                            }}
                        >
                            {i18n.language === 'geo' ? accordionItem.title : accordionItem.titleEng ? accordionItem.titleEng : accordionItem.title}
                        </Button>
                    ) : (
                        <Button
                            onClick={() => handleLinkClick(accordionItem)}
                            startIcon={<AiFillFile />}
                            style={{
                                color: '#3872F2',
                                fontFamily: "'FiraGO-SemiBold'",
                                textDecoration: 'none',
                                cursor: 'pointer',
                                textTransform: 'none',
                                marginTop: 20
                            }}
                        >
                            {i18n.language === 'geo' ? accordionItem.title : accordionItem.titleEng ? accordionItem.titleEng : accordionItem.title}
                        </Button>
                    )}



                </div>
            );
        }

        return (
            <Accordion
                image={accordionItem.icon || ''}
                key={accordionItem.id}
                title={i18n.language === 'geo' ? accordionItem.title : accordionItem.titleEng ? accordionItem.titleEng : accordionItem.title}
                accordionOrder={accordionItem.id}
                style={{textAlign: 'left'}}
                isLogin={accordionItem.id === 40}
            >
                {accordionItem.childrenPermitTypes && accordionItem.childrenPermitTypes.map(renderAccordion)}
            </Accordion>
        );
    };

    return (
        <div>
            {isPopupOpen && <PopupLogin isOpened={isPopupOpen} onClose={togglePopup}/>}

            {isLoading ? (
                <div style={{marginBottom: 20}}>
                    <ServicesLoader/>
                </div>
            ) : (
                <div>
                    <div className="accordion-grid">
                        {accordionData.map(renderAccordion)}
                    </div>
                    {isPopupOpen && <PopupLogin isOpened={isPopupOpen} onClose={togglePopup}/>}
                </div>
            )}
        </div>

    );
}

export default Services;
